import { Entidade } from '@elotech/components';
import axios, { AxiosPromise } from 'axios';

export const getDadosEntidade = (): AxiosPromise<Entidade> =>
  axios.get(`/api/entidade/principal`);
